import * as React from "react";
import { IMAGE_BASE_URL } from "../data/baseURL";
import { AboutDataContext } from "../pages/about/about";

const Excellence = () => {
  const {
    about_approach_excellence: { title, description, heading, image },
  } = React.useContext(AboutDataContext);
  return (
    <section className="my-5" id="excellence">
      <div className="row">
        <div className="col-12 col-md-4 order-2 order-md-1">
          <img
            src={`${IMAGE_BASE_URL}/${image}`}
            alt="excellence"
            className="img-fluid d-block 
            mx-auto mb-5"
            loading="lazy"
          />
        </div>
        <div className="col-12 col-md-8 order-1 order-md-2">
          <h2 className="fs-30">{title}</h2>
          <h3 className="fs-24">{heading}</h3>
        </div>
      </div>
      <p className="fs-16" dangerouslySetInnerHTML={{ __html: description }} />
    </section>
  );
};

export default Excellence;
